<template>
  <div class="navbar">
    <div class="left">
      <div class="time">
        {{ time }}
      </div>
    </div>
    <div class="right-menu">
<!--      <div class="address">{{ location ? location.address : '' }}</div>-->

      <div class="company" @click="showChooseCompany">
        <svg-icon icon-class="company" />
        <span class="company-name">{{ currentCompany ? currentCompany.name : '' }}</span>
        <svg-icon v-if="currentCompany" icon-class="change" />
      </div>
      <el-dropdown @command="handleCommand">
        <div class="dropdown">
          <img v-if="currentCompany.grade && currentCompany.grade === 2" :src="bipBg" alt="" class="vip">
          <el-avatar :src="avatar"></el-avatar>
          <div class="info">
            <span class="unsername">
              {{ currentUser ? currentUser.nickName : '' }}
              <svg-icon icon-class="arrow" class="arrow" />
            </span>
            <span class="roles">{{ roles.join('、') }}</span>
          </div>
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="logout">
            退出登录
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <el-dialog append-to-body :visible.sync="switchCompanyVisible" title="请选择你加入的组织" width="600px">
      <switch-company
        ref="switchCompany"
        :companys="companys"
        @selected-company="selectedCompany"
        :loading="switchLoading"
      />
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import dayjs from 'dayjs'
import bipBg from '@/assets/vip_avatar_bg.png'
import SwitchCompany from '@/components/switch-company'
import {listByUser} from "@/apis/company";

export default {
  components: {
    SwitchCompany
  },
  data() {
    return {
      avatar: require("@/assets/avatar.gif"),
      time: '',
      bipBg,
      switchCompanyVisible: false,
      companys: [],
      switchLoading: false,
    };
  },
  computed: {
    ...mapGetters(["sidebar", 'currentUser', 'location', 'currentCompany', 'roles']),
  },
  created() {
    this.refreshTime()
    setInterval(this.refreshTime, 1000)
    this.loadCompany()
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch("toggleSideBar");
    },
    handleCommand(command) {
      if(command === 'logout') {
        this.logout()
      }
    },
    logout() {
      this.$confirm('确认退出登录', '提示', {
        type: 'warning'
      }).then(() => {
        this.$store.dispatch("user/logout").then(() => {
          this.$router.push({
            name: 'Login',
            query: {
              redirect: this.$route.fullPath
            }
          });
        })
      })
    },
    refreshTime() {
      const arr = ['天', '一', '二', '三', '四', '五', '六']
      this.time = dayjs().format('YYYY-MM-DD HH:mm:ss') + ' | 星期' + arr[dayjs().day()]
    },
    showChooseCompany() {
      if(this.companys.length <= 1) {
        this.$message.warning('没有可切换的企业')
        return
      }
      this.switchCompanyVisible = true
    },
    loadCompany() {
      this.switchLoading = true
      try {
        listByUser(this.currentUser.id)
          .then((resp) => {
            if (resp.code === 1) {
              this.companys = resp.data || []
            }
            this.switchLoading = false
          })
          .catch((error) => {
            console.error(error)
            this.switchLoading = false
          })
      } catch (e) {
        console.error(e)
      }
    },
    selectedCompany(pCompany) {
      const userModel = {userId: this.currentUser.id, companyId: pCompany.id}
      this.switchLoading = true
      this.$store
        .dispatch('user/login', userModel)
        .then(() => {
          this.$store.dispatch('user/selectedCompany', userModel).then(async () => {
            return await this.$store.dispatch('user/getUserInfo', pCompany.id)
          }).then(() => {
            console.log(this.$route)
            if(this.$route.path === '/dashboard') {
              location.reload()
              return
            }
            this.$router.push({
              path: this.redirect || '/',
              query: this.otherQuery
            })
            this.switchLoading = false
            this.switchCompanyVisible = false
          })
        })
        .catch(() => {
          this.switchLoading = false
          this.switchCompanyVisible = false
        })
    },
  },
};
</script>

<style lang="scss" scoped>
.navbar {
  height: 80px;
  line-height: 80px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  display: flex;
  justify-content: space-between;

  .left {
    margin-left: 16px;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;
    display: flex;
    cursor: pointer;

    .company {
      margin: 15px 16px 15px;
      background: rgba(58,111,214,0.1);
      border-radius: 22px;
      padding: 0 16px;
      line-height: 50px;
      display: flex;
      align-items: center;

      .company-name {
        max-width: 280px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin: 0 6px;
      }
    }

    .dropdown {
      margin: 15px 16px 0;
      display: flex;
      position: relative;

      .vip {
        position: absolute;
        top: 0;
        left: 0;
        width: 40px;
        height: 40px;
      }

      .info  {
        display: flex;
        flex-direction: column;
        text-align: left;
        margin-left: 10px;

        .unsername {
          display: inline-block;
          vertical-align: text-bottom;
          font-size: 16px;
          height: 24px;
          line-height: 24px;
          font-weight: bold;

          .arrow {
            margin-left: 4px;
          }
        }

        .roles {
          display: inline-block;
          max-width: 150px;
          height: 20px;
          line-height: 20px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }


    }



    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

  }
}
</style>
